
import {toRefs, reactive, defineComponent, PropType, computed} from 'vue'
import QRCode from 'qrcode-svg'
import DealDTO from "@/models/DealDTO";
import {paymentMethodsHelper} from "@/service/PaymentMethodsHelper"
import {numberFormatter} from "@/service/NumberFormatter"
import InvoiceStateDTO from "@/models/InvoiceStateDTO";
import {dealHasSbpQrPayload, sbpPaymentOpenUrl} from "@/service/sbpQrDeal"

const apiUrl = window.API_URL;

function dealFromProps(raw: unknown): DealDTO | null {
  if (typeof raw !== 'object' || raw === null) {
    return null
  }
  return raw as DealDTO
}

export default defineComponent({
  props: {
    deal: {
      type: Object as PropType<DealDTO>,
      default: false
    },
    invoice: {
      type: Object as PropType<InvoiceStateDTO>,
      default: false
    }
  },
  setup(props) {

    const state = reactive({
      copyHintTimeout: {'amount': null, 'req': null} as any,
    });

    const isManualSbpQrWaiting = computed(() => {
      const deal = dealFromProps(props.deal)
      if (!deal || deal.paymentOption !== 'MANUAL_SBP_QR') {
        return false
      }
      return !dealHasSbpQrPayload(deal)
    });

    const sbpOpenUrl = computed(() => {
      const deal = dealFromProps(props.deal)
      return deal ? sbpPaymentOpenUrl(deal) : ''
    });

    const qrCodeImageSrc = computed(() => {
      const deal = dealFromProps(props.deal)
      if (!deal) {
        return ''
      }
      const rawLink = typeof deal.qrCodeLink === 'string' ? deal.qrCodeLink.trim() : ''
      if (rawLink) {
        const q = new QRCode({
          content: rawLink,
          width: 300,
          height: 300,
          padding: 2,
          join: true,
          xmlDeclaration: false,
          container: 'svg-viewbox',
          color: '#000000',
          background: '#ffffff',
        })
        const svg = q.svg()
        return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
      }
      return `${apiUrl}/api/public/invoices/${deal.id}/qr-code`
    });

    return {
      ...toRefs(state),
      isManualSbpQrWaiting,
      sbpOpenUrl,
      qrCodeImageSrc,
      paymentMethodsHelper,
      numberFormatter,
      apiUrl
    }
  }
})
